<template>
  <div class="w-100 bg-white min-vh-100">
    <Navbar />
    <block :height="83"></block>
    <div class="ga-container d-block pb-5">
      <div v-if="bookingContext.is_load" class="w-100 py-4">
        <loader />
      </div>
      <template v-else>
        <div class="w-100 pt-4" v-if="bookingContext.error != ''">
          <ErrorMessage :message="bookingContext.error" />
        </div>
        <div v-else class="w-100 pt-4">
          <div class="row">
            
            <!-- MAIN CONTENT -->
            <div class="col-xl-8 col-lg-7 col-md-12 order-lg-1 order-2">
              <!-- DATE & TIME SELECTION -->
              <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-4">
                <p class="mb-1 heading-6-1">Choose Your Reservation Details</p>
                <p class="mb-4 body-3-3-1">Select the date and time you plan to dine with us.</p>
                
                <div class="row">
                  <div class="col-md-6 mb-md-0 mb-3">
                    <p class="mb-2 body-2-4">Select Date</p>
                    <div 
                      class="w-100 border-form radius-6 d-flex justify-content-between p-3 cursor-pointer" 
                      @click="bookingContext.toggleDetailCalendar()"
                      v-if="bookingContext.form.date.startDate != null">
                      <div class="align-self-center">
                        <p class="mb-0 body-2-4">{{ $formatDate(bookingContext.form.date.startDate) }}</p>
                      </div>
                      <div class="align-self-center">
                        <svg class="lh-1" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.72599 16H14.5849C16.3993 16 17.3022 15.0971 17.3022 13.3087V2.70862C17.3022 0.92024 16.3993 0.0173645 14.5849 0.0173645H2.72599C0.911556 0.0173645 0 0.911558 0 2.70862V13.3087C0 15.1058 0.911556 16 2.72599 16ZM2.59577 14.6022C1.82311 14.6022 1.39772 14.1943 1.39772 13.3868V5.20021C1.39772 4.40151 1.82311 3.9848 2.59577 3.9848H14.6977C15.4704 3.9848 15.9045 4.40151 15.9045 5.20021V13.3868C15.9045 14.1943 15.4704 14.6022 14.6977 14.6022H2.59577Z" fill="black" fill-opacity="0.85" />
                        </svg>
                      </div>
                    </div>
                    <div class="w-100 pos-calendar height-animated mt-2" :class="{'active': bookingContext.date_setting.show_calendar}">
                      <date-range-picker 
                        class="w-100" 
                        v-model="bookingContext.form.date" 
                        auto-apply 
                        :ranges="false"
                        opens="inline" 
                        :min-date="bookingContext.date_setting.min_date" 
                        :date-format="bookingContext.dateFormat"
                        :single-date-picker="true">
                        <template #date="calendar_date">
                          <div class="pos-calendar-item">
                            <p class="font-lato-regular text-14 lh-1 mb-0">{{bookingContext.formatDateNumber(calendar_date.date)}}</p>
                          </div>
                        </template>
                      </date-range-picker>
                    </div>
                    <p class="mb-0 mt-2 body-2 text-danger" v-if="bookingContext.validation_form.date">Please select reservation date</p>
                  </div>
                  <div class="col-md-6">
                    <p class="mb-2 body-2-4">Select Time</p>
                    <b-dropdown ref="dd_time_wide" variant="link" class="dd-no-p" menu-class="time_dd w-100" no-caret block :disabled="bookingContext.form.date.startDate == null">
                      <template #button-content>
                        <div class="w-100 border-form radius-6 d-flex justify-content-between p-3">
                          <div class="align-self-center lh-1">
                            <p class="mb-0 body-2-2-1 text-danger" v-if="bookingContext.form.date.startDate != null && bookingContext.form.time.list.length == 0"><i>Sorry, there are no time available on this date.</i></p>
                            <template v-else>
                              <p class="mb-0 body-2-4" v-if="bookingContext.form.time.selected != ''">{{ bookingContext.form.time.selected }}</p>
                              <p class="mb-0 body-2-2-1" v-else><i>Select time</i></p>
                            </template>
                          </div>
                          <div class="align-self-center lh-1">
                            <svg class="lh-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.99605 15.9921C12.3704 15.9921 15.9921 12.3626 15.9921 7.99605C15.9921 3.62175 12.3626 0 7.98823 0C3.62175 0 0 3.62175 0 7.99605C0 12.3626 3.62959 15.9921 7.99605 15.9921ZM7.99605 14.6595C4.29593 14.6595 1.34052 11.6962 1.34052 7.99605C1.34052 4.29593 4.28809 1.33268 7.98823 1.33268Z" fill="black" fill-opacity="0.85" />
                            </svg>
                          </div>
                        </div>
                      </template>
                      <b-dropdown-item href="#" v-for="(time,index) in bookingContext.form.time.list" :key="index" @click="bookingContext.selectTimeService(time)">
                        <p class="body-2-1 mb-0 py-2">{{ time }}</p>
                      </b-dropdown-item>
                    </b-dropdown>
                    <p class="mb-0 mt-2 body-2 text-danger" v-if="bookingContext.validation_form.time">Please select reservation time</p>
                  </div>
                </div>
              </div>

              <!-- GUEST QUANTITY -->
              <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-4" id="mid-section-wide">
                <p class="mb-1 heading-6-1">Number of Guests</p>
                <p class="mb-4 body-3-3-1">Specify the total number of people in your party.</p>
                
                <div class="row">
                  <div class="col-md-6 mb-3 mb-md-0 text-center">
                    <div class="w-100 border-form radius-12 p-4">
                      <p class="mb-3 body-2-4">Adults</p>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="pos-order-qty border-green shadow-sm" @click="bookingContext.changeQtyGuest('adult','minus')">
                          <svg width="16" height="3" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 2.28571H0V0H16V2.28571Z" class="fill-primary" />
                          </svg>
                        </div>
                        <div class="px-5">
                          <p class="mb-0 font-lato text-32 font-bold">{{ bookingContext.form.guest.adult }}</p>
                        </div>
                        <div class="pos-order-qty border-green shadow-sm" @click="bookingContext.changeQtyGuest('adult','plus')">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z" class="fill-primary" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 text-center">
                    <div class="w-100 border-form radius-12 p-4">
                      <p class="mb-3 body-2-4">Children</p>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="pos-order-qty border-green shadow-sm" @click="bookingContext.changeQtyGuest('child','minus')">
                          <svg width="16" height="3" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 2.28571H0V0H16V2.28571Z" class="fill-primary" />
                          </svg>
                        </div>
                        <div class="px-5">
                          <p class="mb-0 font-lato text-32 font-bold">{{ bookingContext.form.guest.child }}</p>
                        </div>
                        <div class="pos-order-qty border-green shadow-sm" @click="bookingContext.changeQtyGuest('child','plus')">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z" class="fill-primary" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- GUEST FORM -->
              <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-4" id="for-guest-form-wide">
                <p class="mb-1 heading-6-1">Your Contact Details</p>
                <p class="mb-4 body-3-3-1">Provide your information for reservation confirmation.</p>
                <GuestForm ref="guestFormWide" type="TABLE" page-design-type="WIDE_VIEW"></GuestForm>
              </div>

              <!-- SPECIAL REQUESTS -->
              <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
                <p class="mb-1 heading-6-1">Special Requests</p>
                <p class="mb-4 body-3-3-1">Any preferences or special requests? Let us know!</p>
                <textarea class="p-3 body-2-1 w-100 border-form radius-6" rows="4" placeholder="Mention dietary restrictions, occasion, etc." v-model="bookingContext.form.notes"></textarea>
              </div>

            </div>

            <!-- SIDEBAR SUMMARY -->
            <div class="col-xl-4 col-lg-5 col-md-12 order-lg-2 order-1 mb-lg-0 mb-5">
              <div class="sticky-top" style="top: 100px;">
                <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey overflow-hidden">
                  <div class="p-4 bg-top-black">
                    <p class="mb-0 body-2-2 font-semibold text-16 text-white">Reservation Summary</p>
                    <p class="mb-0 body-2-2 font-bold text-20 text-white">{{ bookingContext.getMerchant.name }}</p>
                  </div>
                  <div class="p-4">
                    <div class="w-100 d-flex justify-content-between mb-3 pb-3 border-b-semi-grey-dashed-2">
                      <div>
                        <p class="mb-0 body-3-3-1">Date</p>
                        <p class="mb-0 body-2-4" v-if="bookingContext.form.date.startDate">{{ $formatDate(bookingContext.form.date.startDate) }}</p>
                        <p class="mb-0 body-3 text-semi-light" v-else>Not selected</p>
                      </div>
                      <div class="text-right">
                        <p class="mb-0 body-3-3-1">Time</p>
                        <p class="mb-0 body-2-4" v-if="bookingContext.form.time.selected">{{ bookingContext.form.time.selected }}</p>
                        <p class="mb-0 body-3 text-semi-light" v-else>Not selected</p>
                      </div>
                    </div>
                    <div class="w-100 d-flex justify-content-between mb-4">
                      <div>
                        <p class="mb-0 body-3-3-1">Party Size</p>
                        <p class="mb-0 body-2-4">{{ bookingContext.form.guest.adult }} Adult{{ bookingContext.form.guest.adult > 1 ? 's' : '' }}<span v-if="bookingContext.form.guest.child > 0">, {{ bookingContext.form.guest.child }} Child{{ bookingContext.form.guest.child > 1 ? 'ren' : '' }}</span></p>
                      </div>
                    </div>

                    <div class="w-100" v-if="bookingContext.error_push != ''">
                      <ErrorMessage :message="bookingContext.error_push" class="mb-3" />
                    </div>

                    <state-button variant="primary" size="xl" block :click="bookingContext.submitForm" :disabled="bookingContext.is_load">Confirm Reservation</state-button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </template>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Navbar from '@/components/hotel/concierge/general/Navbar';
  import Footer from '@/components/hotel/concierge/general/Footer';
  import GuestForm from '@/components/hotel/concierge/pos/GuestForm';
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

  export default {
    components:{
      Navbar,
      Footer,
      GuestForm,
      DateRangePicker
    },
    inject: ['bookingContext'],
    methods: {
      validateGuestForm() {
        return this.$refs.guestFormWide.validateForm()
      }
    }
  }
</script>

<style scoped>
  .bg-top-black {
    background: #222;
  }
  .pos-calendar-item {
    padding: 8px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/layouts/BookingTableWideLayout.vue